export enum ToggleTypes {
  MarkDownToggle = 'MarkDownToggle',
  DarkModeToggle = 'DarkModeToggle',
  PreviewModeToggle = 'PreviewModeToggle',
}
